import React from 'react'

const PrescriberCalls = () => {
  return (
    <div>PrescriberCalls</div>
  )
}

export default PrescriberCalls